module.exports = "/fonts/fa-brands-400.woff2?3654744dc6d6c37c9b3582b57622df5e";